import React from 'react';
import striptags from 'striptags'
import parse from 'html-react-parser';
import { IQuestionEditor, IQuestionEditorState } from 'app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions';
import { Dropdown } from 'react-bootstrap';
import './questionsNavigator.scss'
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

export interface QuestionsNavigatorProps {
  questions: IQuestionEditorState[] | IQuestionEditor[]
  currentQuestion: IQuestionEditorState | IQuestionEditor
  onChangeQuestion?: (question: IQuestionEditorState | IQuestionEditor)=>any
}

interface IOptionsClickQuestion{
  type?: 'next' | 'prev',
  question?: IQuestionEditor | IQuestionEditorState
}

const QuestionsNavigator: React.SFC<QuestionsNavigatorProps> = (props) => {

  const {t} = useTranslation()

  /**
   * @INFO Obtener el numero de la pregunta actual y el total
   * @returns
   */
  const getNumberQuestions = () => {
    let idxCurrentQuestion = getCurrentPosition()
    if(idxCurrentQuestion >= 0){
      return `${t('editor.resources.exercise.question')} ${idxCurrentQuestion+1} ${t('editor.resources.exercise.of')} ${getQuestionsList().length}`
    }else{
      if(
        props.currentQuestion.question.question_category.name === 'container' &&
        props.currentQuestion.childs?.length
      ){
        idxCurrentQuestion = getCurrentPosition(props.currentQuestion.childs[0])
        if(idxCurrentQuestion >= 0){
          return `${t('editor.resources.exercise.question')} ${idxCurrentQuestion+1} ${t('editor.resources.exercise.of')} ${getQuestionsList().length}`
        }
      }
    }
    return t('editor.resources.exercise.select_question')
  }

  /**
   * @INFO Click en cambiar de pregunta
   * @param options
   */
  const handleClickQuestion = (options?: IOptionsClickQuestion) => {
    const currentIndex = getCurrentPosition()
    const questions = getQuestionsList()
    if(!questions.length) return
    if(options?.type){
      if(options.type === 'next'){
        sendOnChangeEvent(questions[currentIndex+1])
      }else if (options.type === 'prev'){
        sendOnChangeEvent(questions[currentIndex-1])
      }
    }else if(options?.question){
      sendOnChangeEvent(options.question)
    }
  }

  /**
   * @INFO Obtener la posición actual de la pregunta seleccionada
   * @returns
   */
  const getCurrentPosition = (_question?: IQuestionEditor | IQuestionEditorState) => {
    let auxQuestion = {...props.currentQuestion}
    if(_question){
      auxQuestion = {..._question}
    }
    const idxCurrentQuestion = getQuestionsList()?.findIndex((item) => item.question._id === auxQuestion.question._id)
    return idxCurrentQuestion
  }



  /**
   * @INFO Enviar el evento de cambio
   * @param question
   */
  const sendOnChangeEvent = (question: IQuestionEditor | IQuestionEditorState) => {
    if(props.onChangeQuestion){
      props.onChangeQuestion(question)
    }
  }

  /**
   * @INFO Obtener el estado de habilitado o no del botón de siguiente y atrás
   */
  const getDisableState = (type: 'next' | 'prev') => {
    if(!getQuestionsList()?.length) return true
    const currentPosition = getCurrentPosition()
    const totalLength = getQuestionsList().length
    if(type === 'next'){
      if(currentPosition >= totalLength-1){
        return true
      }else{
        return false
      }
    }else if(type === 'prev'){
      if(currentPosition <= 0){
        return true
      }else{
        return false
      }
    }else{
      return true
    }
  }

  /**
   * @INFO Obtener lista de preguntas
   * @returns
   */
  const getQuestionsList = () => {
    if(props.questions?.length){
      const response = (props.questions as IQuestionEditorState[]).reduce((acum: IQuestionEditorState[], item) => {
        if(item.question.question_category.name === 'container'){
          item.childs?.forEach((itemChild) => {
            acum.push(itemChild)
          })
        }else{
          acum.push(item)
        }
        return acum
      }, [])
      return [...response]
    }else{
      return []
    }
  }

  return (
    <div className="questions_navigator-layout">
      <div className="container-icon-arrow">
        <MdKeyboardArrowLeft
          className={`icon-arrow ${getDisableState('prev') ? 'disable' : ''}`}
          onClick={getDisableState('prev') ? undefined : ()=>handleClickQuestion({type: 'prev'})}
        />
      </div>
      <Dropdown>
        <Dropdown.Toggle
          id="dropdown-questions-list"
          className='btn-questions-toggle'
        >
          {getNumberQuestions()}
        </Dropdown.Toggle>

        <Dropdown.Menu
          className='container-items-question'
        >
          {getQuestionsList()?.length ?
            getQuestionsList().map((itemQuestion: IQuestionEditorState | IQuestionEditor, idxQuestion) => (
              <Dropdown.Item
                key={itemQuestion.question._id}
                onClick={() => handleClickQuestion({question: itemQuestion})}
                className={`item-question ${itemQuestion.question._id === props.currentQuestion?.question?._id ? 'active' : ''}`}
              >
                {/* {`${idxQuestion+1}  ${parse(striptags(itemQuestion.question.content))}`} */}
                <span>
                  {idxQuestion+1}
                </span>
                {parse(striptags(itemQuestion.question.content))}
              </Dropdown.Item>
            ))
          :null}
        </Dropdown.Menu>
      </Dropdown>
      <div className="container-icon-arrow">
        <MdKeyboardArrowRight
          className={`icon-arrow ${getDisableState('next') ? 'disable' : ''}`}
          onClick={getDisableState('next') ? undefined : ()=>handleClickQuestion({type: 'next'})}
        />
      </div>
    </div>
  );
}

export default QuestionsNavigator;
